import './App.css';
import React, {Fragment,useEffect,useState} from 'react';
import AppWrapper from './components/AppWrapper';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {RecoilRoot} from 'recoil';
import { useTranslation } from 'react-i18next';
import constants from './common/constants';

function App() {  
    const { i18n } = useTranslation();
    const currentOrigin = window.location.origin;
    const url = new URL(currentOrigin);
    const hostnameParts = url.hostname.split('.');
    const subdomain = hostnameParts[0];

    const getOperatorFromSubdomain = (subdomain) => {
        const subdomainInfo = constants.SUBDOMAINS.find(sub => sub.name === subdomain);
        localStorage.setItem('currentOperator', subdomainInfo.operator);
        return subdomainInfo.operator
    };
    
      // Get operator based on subdomain
    const operator = getOperatorFromSubdomain(subdomain);
    const language = constants.Operators[operator]?.DEFAULT_LANG || {};

    if((i18n.language == "en-US" || i18n.language == "en-GB" || i18n.language == "fr-FR" || i18n.language == "en-AU" ) && language){
        i18n.changeLanguage(language.CODE);
    }
  

    useEffect(() => {
            const images = document.querySelectorAll('.rtl-image');
            const artcards = document.querySelectorAll('.rtl-art-card');
            const swiperslides = document.querySelectorAll('.rtl-swiper-slide-mr');
            
            if (i18n.language === 'ar') {
                    document.body.style.direction = 'rtl';
                    images.forEach(image => {
                        image.style.transform = 'scaleX(-1)';
                    });
                    artcards.forEach(artcard => {
                        artcard.style.paddingRight = '30px';
                    });
                    swiperslides.forEach(swiperslide => {
                        swiperslide.style.setProperty('margin-right', '0px', 'important');
                        swiperslide.style.setProperty('margin-left', '30px', 'important');
                    }); 
                }
      

        const handleResize = () => {
            const currentWindowWidth = window.innerWidth;
            const modals = document.querySelectorAll('.modal');
            const videocomponents = document.querySelectorAll('.video');
            const footerspans = document.querySelectorAll('.rtl-span');
            if (i18n.language === 'ar') {
              
                if(currentWindowWidth < 576){
                    modals.forEach(element => {
                        element.style.left="37.5%";
                    });
                }else {
                    modals.forEach(element => {
                        element.style.left="50%";
                    });
                }
                if(currentWindowWidth < 767){
                    videocomponents.forEach(element => {
                        element.style.setProperty('text-align', 'right', 'important');
                    });
                }else {
                    videocomponents.forEach(element => {
                        element.style.setProperty('text-align', 'center', 'important');
                    });
                }
                if (currentWindowWidth > 768) {
                    footerspans.forEach(footerspan => {
                        footerspan.style.paddingRight = '50px';
                    });
                } else {
                    footerspans.forEach(footerspan => {
                        footerspan.style.paddingRight = '0px';
                    });
                }
            } 
        };
    
        // Initial call
        handleResize();
    
        // Add resize event listener
        window.addEventListener('resize', handleResize);
    
        // Cleanup: remove event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [i18n.language]);

    return (
        <Fragment>  
            <HelmetProvider>
                <Helmet>
                    <title>Welbe</title>
                </Helmet>
                <RecoilRoot>
                    <AppWrapper hostname={subdomain} />
                </RecoilRoot>
                </HelmetProvider>  
        </Fragment>
    );
}

export default App;
